import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Canvases } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { isCanvasDetailKey } from '~/swr-hooks/canvases/useCanvas';
import { isCanvasesListKey } from '~/swr-hooks/canvases/useListCanvases';

export type UsePrivateCanvasesUpdateCanvasMutationParams = Extract<
  NonNullable<Parameters<typeof Canvases.update>[0]>,
  { canvases: unknown }
>;

export const usePrivateCanvasesUpdateCanvasMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UsePrivateCanvasesUpdateCanvasMutationParams) => callAirApi(() => Canvases.update(params)),
    onSuccess: () => {
      queryClient.invalidateQueries({ predicate: (query) => isCanvasDetailKey(query.queryKey) });
      queryClient.invalidateQueries({ predicate: (query) => isCanvasesListKey(query.queryKey) });
    },
  });
};
